<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }"> </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Create your user profile</span>
        </v-card-title>
        <v-alert
          type="error"
          v-if="errorMessage !== false"
          transition="scale-transition"
          rounded
          contain
        >{{errorMessage}}
        </v-alert>
        <v-alert type="success" :value="true" tile> Record found. </v-alert>
        <v-alert type="info" color="secondary" :value="true" tile>
          Please create an account to access your records.
        </v-alert>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="mdi-account"
                    label="E-Mail"
                    v-model="email"
                    :rules="emailRules"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    prepend-icon="mdi-lock"
                    :rules="passwordRules"
                    :type="false ? 'text' : 'password'"
                    label="New Password"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="confirmPassword"
                    prepend-icon="mdi-lock-check"
                    :rules="passwordConfirm"
                    :type="false ? 'text' : 'password'"
                    label="Confirm New Password"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="registered === false">
          <v-btn class="px-5 mb-3" textarea depressed color="secondary" @click="cancelRegister">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="px-5 mb-3"
            :disabled="!valid"
            textarea
            depressed
            color="secondary"
            @click="validate"
          >
            Create
          </v-btn>
        </v-card-actions>
        <div v-else>
          <lottie
            id="lottie"
            style="position: inherit"
            :options="defaultOptions"
            :height="100"
            :width="100"
            v-on:animCreated="handleAnimation"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import lottie from 'vue-lottie';
import * as animationData from '../assets/checkmark.json';

export default {
  components: {
    lottie,
  },
  props: { dialog: Boolean, user: Object, loadingButton: Boolean },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
      valid: true,
      email: '',
      password: '',
      confirmPassword: '',
      errorMessage: false,
      registered: false,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        (v) => !!v || 'Password required',
        (v) => (v && v.length >= 5) || 'Password must have 5+ characters',
        (v) => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
        (v) => /(?=.*\d)/.test(v) || 'Must have one number',
      ],
      passwordConfirm: [
        (v) => !!v || 'Confirm password',
        (v) => v === this.password || 'Passwords do not match',
      ],
    };
  },
  methods: {
    async submitUser() {
      // Map form to the correct variables for user registration
      const email = this.email.toLowerCase();
      const { password } = this;
      const { insurance, birthDate, memberId, username } = this.user;
      // Get reCAPTCHA token from Google's reCAPTCHA API
      // eslint-disable-next-line max-len
      // const recaptchaToken = await grecaptcha.execute('6Lfyv1wmAAAAADR_KMJEjMea6feUSGgNClYT8gmZ', {
      //   action: 'submit',
      // });
      const recaptchaToken = true;
      const data = {
        email,
        password,
        username,
        birthDate,
        insurance,
        memberId,
        recaptchaToken,
        role: 'Member',
      };
      axios
        .post('/api/register', data)
        .then(() => {
          this.registered = true;
          this.errorMessage = false;
          setTimeout(() => {
            this.$emit('login', email, password);
          }, 2000);
          console.log('Registered user successfully.');
        })
        .catch((err) => {
          switch (err.response.status) {
            case 409:
              this.errorMessage = err.response.data.message;
              break;
            default:
              this.errorMessage = 'An error has ocurred.';
              break;
          }
        });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.submitUser();
      }
    },
    cancelRegister(){
      this.$emit('loadingButton', false);
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    createUser(e) {
      console.log('created new user', e);
    },
  },
};
</script>
